import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const propTypes = {
  title: PropTypes.any.isRequired,
  text: PropTypes.any.isRequired,
  button: PropTypes.element,
};

const titleType = {
  title: PropTypes.any.isRequired,
};

const defaultProps = {
  button: (
    <a className="btn" href={`/${(COUNTRY || '').toLowerCase()}`}>
      <FormattedMessage id="offer.submit.backhome" />
    </a>
  ),
};

const Credit24LoanErrorBody = ({ title }) => (
  <>
    {
            COUNTRY === 'FI'
              ? <span className="icon icon--error-neutral" />
              : <span className="icon icon--sad-face" />
        }
    <h1 className="loan-form__step-title loan-form__step-title--error">
      {title}
    </h1>
  </>
);

const RebrandingLoanErrorBody = ({ title }) => (
  <>
    <h1 className="loan-form__step-title loan-form__step-title--error">
      {title}
    </h1>
    <span className="icon icon--sad-face" />
  </>
);

const LoanError = ({ title, text, button }) => (
  <div className="loan-form__step loan-form__step--space-top-bottom">
    <div className="loan-form__step-body txt-center">
      {
                REBRANDING
                  ? <RebrandingLoanErrorBody title={title} />
                  : <Credit24LoanErrorBody title={title} />
            }
      <p>
        {text}
      </p>
    </div>
    <div className="loan-form__footer loan-form__footer--center">
      {button}
    </div>
  </div>
);

LoanError.propTypes = propTypes;
LoanError.defaultProps = defaultProps;
Credit24LoanErrorBody.propTypes = titleType;
RebrandingLoanErrorBody.propTypes = titleType;

export default LoanError;
